// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__yt5_M","detailsBorder":"styles_detailsBorder__2eMOJ"};